import Typography from "../../components/Typography/Typography";
import { AthenaLogo } from "../../Icons/AthenaLogo";

const LoadingOverlay = () => {
  const athenaTooltips = [
    "Organizza i tuoi appunti di studio in un unico posto con Athena",
    "Salva risorse web direttamente nella tua libreria Athena",
    "Usa Athena per ottimizzare il tuo tempo di studio",
    "Accedi ai tuoi materiali didattici ovunque ti trovi",
    "Imposta obiettivi di studio e monitora i tuoi progressi",
    "Sincronizza i tuoi materiali tra tutti i tuoi dispositivi",
    "Categorizza automaticamente i tuoi contenuti per un accesso rapido",
    "Trova rapidamente quello che cerchi con la funzione di ricerca avanzata",
    "Sapevi che puoi esportare il tuo indice in diversi formati?",
    "Traccia il tempo dedicato a ogni capitolo con Athena",
    "Sfrutta la vista calendario per pianificare le tue sessioni di studio",
    "Organizza i tuoi libri e materiali in biblioteche virtuali"
  ];
  
  function getRandomTooltip() {
    const randomIndex = Math.floor(Math.random() * athenaTooltips.length);
    return athenaTooltips[randomIndex];
  }
  
  const tooltipToShow = getRandomTooltip();

  return (
    <div className="fixed inset-0 bg-gray-100 z-50 flex flex-col items-center justify-between">
        <div className="flex-1" />
        
        <div className="flex flex-col px-8 gap-4 items-center justify-center">
          <AthenaLogo size={120} color="#CFCEC9"/>

          <Typography size={16} weight="md" color="gray-600" align="center">
            {tooltipToShow}
          </Typography>
        </div>
        
        <div className="flex-1" />
        
        <div className="w-36 h-2 bg-gray-200 overflow-hidden relative mb-16 rounded-full">
          <div 
            className="absolute h-full bg-accent rounded-full"
            style={{
              width: '70%',
              animation: 'moveInfinite 2s linear infinite'
            }}
          />
          <style jsx>{`
            @keyframes moveInfinite {
              0% {
                transform: translateX(-100%);
              }
              100% {
                transform: translateX(140%);
              }
            }
          `}</style>
        </div>
    </div>
  );
};

export default LoadingOverlay;